export default __webpack_public_path__ + "static/media/prev_black.2156f63d.png";